import React from 'react'
import Link from 'gatsby-link'
import $ from 'jquery'
import moment from 'moment'
moment.locale('es')

import LazyLoad from 'react-lazyload';

import DFPAdsProvider from '@univision/fe-commons/dist/components/ads/dfp/DFPAdsProvider';
import DFPAd from '@univision/fe-commons/dist/components/ads/dfp/DFPAd';
import BKPIndicator from '@univision/fe-commons/dist/components/breakpoint/BreakPointIndicator';


import { pageData } from '../config/advertising';

import adHelper from '@univision/fe-commons/dist/utils/ads/adHelper';
import AdSettings from '@univision/fe-commons/dist/utils/ads/adSettings.json';
import * as AdTypes from '@univision/fe-commons/dist/utils/ads/ad-types';

import { track_click }  from '../components/tracking'
import Tracking  from '../components/tracking'
import BackOpening from '../images/home-opening-optimized.png'

export default class IndexPage extends React.Component {
    componentDidMount(){
        try {
          setTimeout(() => {
            window.scrollTo(0, 0)
          }, 100);
        }catch(e){}
    }
    callDFPAd = (type) => {
        const adSettings = AdSettings[AdTypes[type]];
        const settings = adHelper.getSettings(adSettings);
        return (
          <div style={{ "textAlign": "center" }}>
            <BKPIndicator />
            <div className="container-advertising">
              <DFPAdsProvider
                  env={pageData.env}
                  settings={pageData.data.adSettings}
                  requestParams={pageData.requestParams}
                  contentType={pageData.data.type}
              >
                  <DFPAd {...settings}  />
              </DFPAdsProvider>
            </div>
          </div>
        );
    };
    
    render() {

      let _pages = this.props.data.allSitePage.edges;
      let pages = []
      for (let ip = 0; ip < _pages.length; ip++) {
        let _page1 = _pages[ip];
        if(_page1.node.context != undefined && _page1.node.context.node != null)
        {
          pages.push(_page1);
        }
        
      }

      pages.sort((a,b) => {return a.node.context.node.index - b.node.context.node.index } );
    
      function hacerScroll(e) {
          e.preventDefault();
          $("body, html")
          .stop()
          .animate(
            {
              scrollTop: $('#inicioCapitulo').offset().top - 100
            },
            1000
          );
        }

        function openWindow(e){
          track_click("UCLPortadaShareFB");
          e.preventDefault();
          window.open('https://www.facebook.com/sharer/sharer.php?u='+window.location.href+ '&ttitle=' + encodeURIComponent(video.title) ); 
        }

        function openTwitter(e){
          track_click("UCLPortadaShareTW");
          e.preventDefault();
          window.open('https://twitter.com/intent/tweet?text=' + encodeURIComponent(video.title) + ' ' + encodeURIComponent(window.location.href));
        
        }

        function openMail(e){
          track_click("UCLPortadaShareMail");
          e.preventDefault();
          window.location.href = ('mailto:?subject=' + encodeURIComponent(video.title) + '&body='+encodeURIComponent(video.title)+'. \n\nUn amigo te ha recomendado un artículo que puede ser de tu interés:%20' + encodeURIComponent(window.location.href));
        }

        
        function get_video()
        {
          for (let index = 0; index < pages.length; index++) {
            const page = pages[index];
            if(page.node.context != null && page.node.context.node != null){ 
              if(page.node.context.node.type == "video")
              {
                return page.node.context.node;
              }
            }
          }
          return null;
        }
        let video = get_video();
        let _index = 0;
    return (
      <div className="contenedor_la_otra_cara">
        <Tracking />
        <div className="uvn_la_otra_cara_del_mundial_home">
            <div className="video_full_screen" style={ { backgroundImage: `url(${BackOpening})` } }></div>
            
            <section>
              <div className="datos_video">
                <span className="titulo_video">{ video.title }</span> 
                <span className="descripcion_video">{ video.description }</span>  
                <ul className="compartir">
                  <li className="share_facebook">
                    <a href={"https://www.facebook.com/sharer/sharer.php?u=&t="} title={"Share on Facebook"} target={"_blank"} onClick={openWindow}></a>
                  </li>
                  <li className="share_twitter">
                    <a  href={"https://twitter.com/intent/tweet?"} target={"_blank"} title={"Share on Twitter"}  onClick={openTwitter} ></a>
                   
                  </li>
                  <li className="share_mail"> 
                    <a  href={"mailto:?subject=&body=:%20"} onClick={openMail} ></a>
                  </li>
                </ul> 
        
                <div className="ver_mas" onClick={hacerScroll}>VER MÁS</div>
   
              </div>                          
            </section>
            <LazyLoad > 
                {this.callDFPAd("TOP_AD")}
            </LazyLoad> 
            <ul id="inicioCapitulo">
                {
                  
                  pages.map(({ node }, index) => {
                    if((node.path != '/internal/' && node.path != 'dev-404-page/' && node.path != '/404/' && node.path != '/404.html' && node.path != '/dev-404-page/' && node.path != '/')
                     && (node.context.node.type != "video"))
                    {
                      _index++;
                      var _image_home = "";
                      if(node.context.node.image_home != null)
                      {
                        _image_home = `<img src="${node.context.node.image_home}" class="image_home" />`;
                      }
                        return (
                        <li key={index} className="capitulo">
                            <a href={this.props.location.pathname.replace('index.html', '') + node.path.substring(1) } onClick = { () => {
                                track_click("UCLPortadaEpisodio" + node.context.node.index + "Mas");
                              }}>
                              
                              <span className="titulo_capitulo">{node.context.node.title}</span>
                              <div className="datos_publicacion" dangerouslySetInnerHTML={{ __html: _image_home }}>
                                    {/*<img src={node.context.node.author_image} className={node.context.node.author_image == "" ? "hide": "imagen_autor"} />
                                    <span className="autor">{node.context.node.author_name}</span>
                                    <span className="fecha">{moment(node.context.node.publishDate).format('MMM DD[,] YYYY [-]  h:mm a')}</span> */}
                              </div>
                              <span  className="descripcion_capitulo">{node.context.node.description}</span>
                              <div className="boton_leer">LEER MÁS</div>
                            </a>
                        </li>
                      )
                    }
                  })
                }
            </ul>
        </div> 
        </div>
        )
    }
}
export const pageQuery = graphql`
query Pages {
  allSitePage{
    edges {
      node {
        id
        path
        context 
        {
          slug
          node{
            label
            image_home
            title
            description
            publishDate
            type
            index
            author_name
            author_image
            image_lead
          }
        }
      }
    }
  }
}`


// WEBPACK FOOTER //
// ./src/pages/index.js